var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#90DFAA"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M355.2,188.4v194.4l0,0c0,19.6,15.6,35.2,35.2,35.2s35.2-15.6,35.2-35.2l0,0V188.4H355.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CED5E0"
    },
    d: "M395.6,417.6c-1.6,0.4-3.6,0.4-5.2,0.4c-9.6,0-18.4-4-24.8-10.4s-10.4-15.2-10.4-24.8V188.4H366 v194.4c0,9.6,4,18.4,10.4,24.8C381.2,412.8,388,416.4,395.6,417.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M355.2,382.8L355.2,382.8V99.2H110v283.2c0,19.6,15.6,35.2,35.2,35.2H390 C370.8,418,355.2,402,355.2,382.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M131.2,158.4c0-2,1.6-3.6,3.6-3.6c4.8,0,5.6-4.8,5.6-5.6V122c0-2,1.6-3.6,3.6-3.6s3.6,1.6,3.6,3.6 v27.2c0,0.4,0,3.2-1.6,6c-2,4.4-6,6.4-11.2,6.4C133.2,162.4,131.2,160.4,131.2,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M152.8,140.4c0-12,9.2-22,20.8-22s21.2,10,21.2,22s-9.6,22-21.2,22S152.8,152.4,152.8,140.4z M160,140.4c0,8,6,14.4,13.6,14.4s13.6-6.4,13.6-14.4s-6-14.4-13.6-14.4C166.4,125.6,160,132.4,160,140.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 185.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 220.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.8,
    y: 211.2,
    style: {
      fill: "#E6E9EE"
    },
    width: 103.2,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.8,
    y: 232.8,
    style: {
      fill: "#E6E9EE"
    },
    width: 103.2,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.8,
    y: 254.8,
    style: {
      fill: "#E6E9EE"
    },
    width: 103.2,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.8,
    y: 276.4,
    style: {
      fill: "#E6E9EE"
    },
    width: 103.2,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.8,
    y: 298.4,
    style: {
      fill: "#E6E9EE"
    },
    width: 103.2,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.8,
    y: 320,
    style: {
      fill: "#E6E9EE"
    },
    width: 103.2,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.8,
    y: 342,
    style: {
      fill: "#E6E9EE"
    },
    width: 103.2,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.8,
    y: 363.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 103.2,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.8,
    y: 385.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 103.2,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.2,
    y: 211.2,
    style: {
      fill: "#E6E9EE"
    },
    width: 103.2,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.2,
    y: 232.8,
    style: {
      fill: "#E6E9EE"
    },
    width: 103.2,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.2,
    y: 342,
    style: {
      fill: "#E6E9EE"
    },
    width: 103.2,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.2,
    y: 363.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 103.2,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.2,
    y: 385.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 103.2,
    height: 8.4
  })), /*#__PURE__*/React.createElement("rect", {
    x: 239.2,
    y: 254.8,
    style: {
      fill: "#84DBFF"
    },
    width: 103.2,
    height: 74
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M223.2,137.2c1.6-2,2.4-4.4,2.4-7.2c0-6.4-5.2-12-12-12h-10c-2,0-4,1.6-4,4v36c0,2,1.6,4,4,4h11.6 c7.6,0,13.6-6,13.6-13.6C228.8,144,226.8,140,223.2,137.2z M207.2,125.6h6c2.4,0,4.8,2,4.8,4.4s-2,4.8-4.8,4.8h-6V125.6z M215.2,154.8h-8.4V142h8.4c3.6,0,6.4,2.8,6.4,6.4C221.6,152,218.8,154.8,215.2,154.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.e134bf0dd9484a8cf08dc6b4c37a63b7.svg";
export { ForwardRef as ReactComponent };